import React, { useRef, useEffect } from 'react';

import Input from './AddComment';

const AddThreadBtn = ({ module, component, sendIdentifier = null }) => {
  const inputRef = useRef();
  useEffect(() => {
    inputRef.current.setShow(true);
    inputRef.current.setShowBottom(false);
  }, []);

  return (
    <div className={`add-thread `}>
      <Input
        isThreadInput
        ref={inputRef}
        module={module}
        component={component}
        sendIdentifier={sendIdentifier}
      />
    </div>
  );
};

export default AddThreadBtn;
